import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TooltipModule } from 'primeng/tooltip';
import { AuthStateService } from '../../services/authstate.service';
import { CommonModule, NgStyle } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';
import { NavbarService } from '../../services/navbar.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    DialogModule,
    SelectButtonModule,
    FormsModule,
    DividerModule,
    ButtonModule,
    TooltipModule,
    AvatarModule,
    NgStyle,
    TranslocoDirective
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})

export class NavbarComponent {
  currentPathRoot: string = '';
  submenuContext: string = '';
  submenuPosition: { left?: string; right?: string } | null = null;
  submenuAlignment: 'left' | 'right' = 'left';
  submenuArrowLeft: string = '0';

  constructor(
    public authState: AuthStateService,
    private router: Router,
    public nav: NavbarService
  ) {
    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.submenu-toggler') && !target.closest('.submenu-container')) {
        this.closeSubmenu();
      }
    });

    this.currentPathRoot = this.router.url.split('/')[1];

    router.events.subscribe((event) => {
      this.currentPathRoot = this.router.url.split('/')[1];
    });
  }

  toggleSubmenu(el: HTMLElement, context: string, event: MouseEvent) {
    event.stopPropagation();
    const rect = el.getBoundingClientRect();
    const windowWidth = window.innerWidth;
    const submenuWidth = 150; // Match your CSS min-width
    const rightSpace = windowWidth - rect.right;

    if (this.submenuContext === context && this.nav.submenuVisible) {
      this.closeSubmenu();
    } else {
      if (this.nav.submenuVisible) {
        this.closeSubmenu();
        setTimeout(() => {
          this.openSubmenu(rect, rightSpace < submenuWidth, context);
        }, 150);
      } else {
        this.openSubmenu(rect, rightSpace < submenuWidth, context);
      }
    }
  }

  private openSubmenu(rect: DOMRect, alignRight: boolean, context: string) {
    this.submenuAlignment = alignRight ? 'right' : 'left';

    this.submenuPosition = alignRight
      ? { right: `${window.innerWidth - rect.right}px` }
      : { left: `${rect.left}px` };

    this.submenuArrowLeft = (rect.left + (rect.width / 2)) + "px";

    this.submenuContext = context;
    this.nav.submenuVisible = true;
    this.nav.activeNavItem = context;
  }

  closeSubmenu() {
    this.nav.submenuVisible = false;
    this.nav.activeNavItem = '';
    this.submenuContext = '';
  }
}

